/**
 * Thin client for pac_man_gm session APIs (Option B).
 */
import { ARCADE, API_PATH_PROXY_ENABLED } from '../../../utils/config';
import { acquireGmLease, endGmSession, noteGmState } from '../gmLease';

/** Lease key for this game's shared GM (game_engines/gm_registry.py). */
export const GM_GAME_ID = 'pac_man';

export const PACMAN_GM_BASE = API_PATH_PROXY_ENABLED
    ? (ARCADE.pac_man?.API_BASE || '')
    : '/pacman';

async function parseJson(res) {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(data.error || `Pac-Man GM HTTP ${res.status}`);
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return noteGmState(GM_GAME_ID, data);
}

export async function createPacManSession() {
    await acquireGmLease(GM_GAME_ID);
    const res = await fetch(`${PACMAN_GM_BASE}/session/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}',
    });
    return parseJson(res);
}

export async function movePacManSession(sessionId, direction = null) {
    const body = direction ? { direction } : {};
    const res = await fetch(`${PACMAN_GM_BASE}/session/${sessionId}/move`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    return parseJson(res);
}

export async function deletePacManSession(sessionId) {
    if (!sessionId) return;
    endGmSession(GM_GAME_ID, sessionId);
    try {
        await fetch(`${PACMAN_GM_BASE}/session/${sessionId}/delete`, { method: 'POST' });
    } catch {
        /* best-effort */
    }
}

export const PELLET_POINTS = 8;
export const POWER_POINTS = 25;
export const GHOST_POINTS = 50;
export const CLEAR_BONUS = 200;
export const LIVES = 3;
